import translate from 'counterpart';

translate.registerInterpolations({ project: '' });

export default {
    menu: {
        notdone: 'Что не сделано',
        profile: 'Профиль',
        login: 'Авторизация',
        logout: 'Выйти',
        relog: 'Перезайти',
        request: 'Портфель заявок',
        requestAdd: 'Отправить заявку',
        requestMetroAdd: 'Отправить заявку на подбор',
        requestMetroApproval: 'Согласование заявок',
        requestMetro: 'Заявки на подбор',
        approvalPerson: 'Согласование людей',
        approvalProject: 'Согласование вакансий',
        project: 'Портфель проектов РЕК',
        approvalGroupTitle: 'Согласование',
        projectGroupTitle: 'Проект',
        requestGroupTitle: 'Заявка на вакансию',
        worksheet: 'Сводка РЕК проекта: «%(project)s»',
        worksheetMass: 'Сводка МАП проекта: «%(project)s»',
        main: 'Главная',
        communicator: 'Коммуникатор',
        calendar: 'Календарь',
        projectMass: 'Портфель проектов МАП',

        education: 'Личный кабинет',
        actionVacancy: 'Запись на ОиР',
        application: 'Заявки',
        approvalApplication: 'Согласование заявок',
        events: 'Мероприятия',
        courses: 'Библиотека курсов',
        scenario: 'Сценарий: «%(scenario)s»',
        trainerEvents: 'Мероприятия тренера',
        trainerTimetable: 'Расписание тренера',
        personTimetable: 'Расписание человека',
        remoteCourse: 'Дистанционный курс: «%(name)s»',
        remoteAssesment: 'Дистанционная оценка: «%(name)s»',
        news: 'Новости',
        fileLibrary: 'Документы',

        metroRequest: 'Отправить заявку',
        metroRequestEdit: 'Редактирование заявки',
        metroRequestApproval: 'Согласование заявки',
        metroRequests: 'Заявки',
        metroRequestsApproval: 'Согласование заявок',
    },
};
